// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file events/v1/subscribed_successfully.proto (package events.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Feature } from '../../subscription/v1/addon_pb';
import { file_subscription_v1_addon } from '../../subscription/v1/addon_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file events/v1/subscribed_successfully.proto.
 */
export const file_events_v1_subscribed_successfully: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CidldmVudHMvdjEvc3Vic2NyaWJlZF9zdWNjZXNzZnVsbHkucHJvdG8SCWV2ZW50cy52MSLIAQoWU3Vic2NyaWJlZFN1Y2Nlc3NmdWxseRIaCg1wcmV2aW91c19wbGFuGAEgASgJSACIAQESFgoOYWN0aXZhdGVkX3BsYW4YAiABKAkSNAoSZmVhdHVyZXNfYWN0aXZhdGVkGAMgAygOMhguc3Vic2NyaXB0aW9uLnYxLkZlYXR1cmUSMgoQZmVhdHVyZXNfcmVtb3ZlZBgEIAMoDjIYLnN1YnNjcmlwdGlvbi52MS5GZWF0dXJlQhAKDl9wcmV2aW91c19wbGFuQncKDWNvbS5ldmVudHMudjFCG1N1YnNjcmliZWRTdWNjZXNzZnVsbHlQcm90b1ABWgQuL3BiogIDRVhYqgIJRXZlbnRzLlYxygIJRXZlbnRzXFYx4gIVRXZlbnRzXFYxXEdQQk1ldGFkYXRh6gIKRXZlbnRzOjpWMWIGcHJvdG8z',
        [file_subscription_v1_addon]
    );

/**
 * @generated from message events.v1.SubscribedSuccessfully
 */
export type SubscribedSuccessfully = Message<'events.v1.SubscribedSuccessfully'> & {
    /**
     * @generated from field: optional string previous_plan = 1;
     */
    previousPlan?: string | undefined;

    /**
     * @generated from field: string activated_plan = 2;
     */
    activatedPlan: string;

    /**
     * @generated from field: repeated subscription.v1.Feature features_activated = 3;
     */
    featuresActivated: Feature[];

    /**
     * @generated from field: repeated subscription.v1.Feature features_removed = 4;
     */
    featuresRemoved: Feature[];
};

/**
 * Describes the message events.v1.SubscribedSuccessfully.
 * Use `create(SubscribedSuccessfullySchema)` to create a new message.
 */
export const SubscribedSuccessfullySchema: GenMessage<SubscribedSuccessfully> =
    /*@__PURE__*/
    messageDesc(file_events_v1_subscribed_successfully, 0);
